{
  "page": {
    "title": "Clés API",
    "subtitle": "Gérez les clés de l'API Partner Order"
  },
  "section": {
    "aria": "Clés Partner API",
    "title": "Clés API",
    "subtitle": "Créez et gérez les clés de l'API Partner Order. Les secrets ne sont affichés qu'une seule fois."
  },
  "table": {
    "key": "Clé",
    "label": "Libellé",
    "status": "Statut",
    "lastUsed": "Dernière utilisation",
    "usage": "Utilisation (req. / err. / commandes)",
    "actions": "Actions",
    "neverUsed": "jamais utilisée",
    "noActions": "—",
    "revokeOrphanHint": "Cette clé n'a jamais été utilisée — révoquez-la si le secret a été perdu."
  },
  "status": {
    "active": "Active",
    "revoked": "Révoquée"
  },
  "empty": {
    "title": "Aucune clé API pour le moment",
    "subtitle": "Créez une clé pour commencer à utiliser l'API Partner Order depuis vos systèmes.",
    "cta": "Créez votre première clé API"
  },
  "create": {
    "aria": "Créer une clé API",
    "title": "Créer une clé API",
    "subtitle": "Donnez un libellé à la clé pour la reconnaître plus tard.",
    "labelField": "Libellé",
    "labelPlaceholder": "ex. Production",
    "labelRequired": "Saisissez un libellé",
    "copied": "Copiée",
    "copyFailed": "Copiez la clé manuellement"
  },
  "reveal": {
    "title": "Clé API créée",
    "subtitle": "Copiez votre secret maintenant. Pour des raisons de sécurité, il ne sera plus affiché.",
    "warning": "C'est la seule fois où la clé complète est affichée. Conservez-la en lieu sûr — vous ne pourrez plus la revoir.",
    "secretLabel": "Votre clé API",
    "copyAria": "Copier la clé API",
    "done": "J'ai enregistré la clé"
  },
  "revoke": {
    "aria": "Révoquer la clé API",
    "title": "Révoquer cette clé API ?",
    "body": "La clé cesse de fonctionner immédiatement et ne peut pas être restaurée. Toute intégration qui l'utilise commencera à échouer.",
    "confirmTitle": "Confirmer la révocation",
    "confirmBody": "Cette action est définitive. Vous devrez créer une nouvelle clé pour vous reconnecter.",
    "success": "Clé API révoquée",
    "error": "Impossible de révoquer la clé"
  },
  "actions": {
    "create": "Créer une clé API",
    "cancel": "Annuler",
    "continue": "Continuer",
    "revoke": "Révoquer",
    "retry": "Réessayer"
  },
  "errors": {
    "loadFailed": "Impossible de charger vos clés API.",
    "network": "Erreur réseau - vérifiez la connexion"
  }
}
